module.exports = __webpack_public_path__ + "4eef417d.png";